import React from "react";
import { Box, Button, Group, Title } from "@mantine/core";
import { useState } from "react";
import LeaveHistoryTable from "./components/table/leavehistoryTable";
import UserBalanceUpdateModal from "features/admin-leave/components/adduserBalance/adduserbalance";
import { PermissionButton } from "api/permission/buttonpermission";
import { UserPlus, FileDownload, FileUpload, ClipboardCheck } from "tabler-icons-react";
import { UserLeaveBalance } from "api/newLeave/leaveHistory";
import { exportLeaveBalanceReport } from "utils/exportLeaveBalanceReport";
import {
  useDownloadBalanceTemplate,
  useImportBalanceReport,
} from "api/leaveReport/balanceImport";
import ReportImportModal from "components/ReportImportModal";
import PendingBalanceReviewModal from "./components/PendingBalanceReviewModal";

export default function LeaveHistoty() {
  const [opened, setOpened] = useState(false);
  const [filteredData, setFilteredData] = useState<UserLeaveBalance[]>([]);
  const [isExporting, setIsExporting] = useState(false);
  const [importOpened, setImportOpened] = useState(false);
  const [reviewOpened, setReviewOpened] = useState(false);
  const downloadTemplate = useDownloadBalanceTemplate();
  const importBalance = useImportBalanceReport();

  const handleExport = () => {
    try {
      setIsExporting(true);
      exportLeaveBalanceReport(filteredData);
    } finally {
      setIsExporting(false);
    }
  };

  return (
    <Box>
      <Group position="apart" mb="md">
        <Title order={2}>Leave Balance Report</Title>
        <Group>
          <PermissionButton
            permission="reports.leaveBalanceReportExport"
            leftIcon={<FileDownload size={16} />}
            onClick={handleExport}
            loading={isExporting}
            disabled={filteredData.length === 0}
          >
            Export Report
          </PermissionButton>
          <PermissionButton
            permission="employees.userBalance"
            leftIcon={<UserPlus size={16} />}
            onClick={() => setOpened(true)}
          >
            Add User Balance
          </PermissionButton>
          <PermissionButton
            permission="reports.balanceTemplate"
            hideIfNo
            variant="light"
            leftIcon={<FileDownload size={16} />}
            onClick={() => downloadTemplate.mutate()}
            loading={downloadTemplate.isLoading}
          >
            Download Sample Template
          </PermissionButton>
          <PermissionButton
            permission="reports.balanceImport"
            hideIfNo
            variant="light"
            leftIcon={<FileUpload size={16} />}
            onClick={() => setImportOpened(true)}
          >
            Import Report
          </PermissionButton>
          <PermissionButton
            permission="reports.balanceApprove"
            hideIfNo
            variant="light"
            leftIcon={<ClipboardCheck size={16} />}
            onClick={() => setReviewOpened(true)}
          >
            Pending Balance Imports
          </PermissionButton>
        </Group>
      </Group>

      <ReportImportModal
        opened={importOpened}
        onClose={() => setImportOpened(false)}
        title="Import Leave Balances"
        onImport={(file) => importBalance.mutateAsync(file)}
        isImporting={importBalance.isLoading}
      />
      <PendingBalanceReviewModal
        opened={reviewOpened}
        onClose={() => setReviewOpened(false)}
      />
      {/* <Divider mb="md" /> */}
      <LeaveHistoryTable onDataUpdate={setFilteredData} />
      {/* <AddLeaveRequestModal opened={opened} onClose={() => setOpened(false)} /> */}
      <UserBalanceUpdateModal
        opened={opened}
        onClose={() => setOpened(false)}
      />
    </Box>
  );
}
